// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AdicionaOrcamentoServicoNoCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_AdicionaOrcamentoServicoNoCompromissoResponseDados = boolean;

export type Agenda_AdicionaOrcamentoServicoNoCompromissoResponse = ApiResponse<Agenda_AdicionaOrcamentoServicoNoCompromissoResponseDados>;

registerResponseContract('Agenda_AdicionaOrcamentoServicoNoCompromissoResponse', {})
